import React from 'react';
import styled from 'styled-components';
import { IconBase } from '../Base';
const HiddenGroup = styled.g `
  path {
    opacity: 0;
  }
`;
export const IconChecklist = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("g", { fill: "none", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", style: { stroke: 'var(--icon-color)' } },
            React.createElement(HiddenGroup, null,
                React.createElement("path", { d: "M10.7933 8.36833H14.1267" }),
                React.createElement("path", { d: "M5.79333 8.14L6.55917 8.83L8.10083 7.44167" })),
            React.createElement("g", null,
                React.createElement("path", { d: "M10.7933 8.36833H14.1267" }),
                React.createElement("path", { d: "M5.79333 8.14L6.55917 8.83L8.10083 7.44167" })),
            React.createElement("g", null,
                React.createElement("path", { d: "M10.7933 12.535H14.1267" }),
                React.createElement("path", { d: "M5.79333 12.3067L6.55917 12.9967L8.10167 11.6083" })),
            React.createElement("path", { d: "M13.3333 2.5H6.66667C4.36548 2.5 2.5 4.36548 2.5 6.66667V13.3333C2.5 15.6345 4.36548 17.5 6.66667 17.5H13.3333C15.6345 17.5 17.5 15.6345 17.5 13.3333V6.66667C17.5 4.36548 15.6345 2.5 13.3333 2.5Z" }))));
};
//# sourceMappingURL=Checklist.js.map